// true on a phone-size screen (≤ 640 px wide) — pages switch their wide tables to cards (user 2026-10-15)
import { useEffect, useState } from 'react';

const QUERY = '(max-width: 640px)';
export const useIsPhone = () => {
  const [phone, setPhone] = useState(() => typeof window !== 'undefined' && window.matchMedia(QUERY).matches);
  useEffect(() => {
    const m = window.matchMedia(QUERY);
    const on = () => setPhone(m.matches);
    m.addEventListener ? m.addEventListener('change', on) : m.addListener(on);
    return () => { m.removeEventListener ? m.removeEventListener('change', on) : m.removeListener(on); };
  }, []);
  return phone;
};
